import { GET } from '@/request/index'
import URL from '@/request/api/url'

export const fetchNewList = (data) => {
  return GET(URL.NEWS_LIST, { data })
}
export const fetcTopNewList = (data) => {
  return GET(URL.NEWS_LIST2, { data })
}
/**
 * 获取新闻详情和招聘岗位详情
 * @param {id} id
 * @returns
 */
export const fetchRecruitmentDetail = (id) => {
  return GET(URL.RECRUITMENT_DETAIL + id)
}
